import { ITag } from "@fluentui/react";
import { TenantFilters, ExtensionVersionFilters } from "../../../Types";

function parseInitialTags(analysisTags: any): ITag[] {
  if (Array.isArray(analysisTags)) {
    return analysisTags
      .flat()
      .filter((t) => typeof t === "string")
      .map((t) => ({ key: t, name: t }));
  }
  return [];
}

// New functions for advanced tenant filters
function parseTenantFilterAdvancedTags(tenantFilters?: TenantFilters): ITag[] {
  if (!tenantFilters || !tenantFilters.tenantList) return [];
  return tenantFilters.tenantList
    .filter(Boolean)
    .map((name) => ({ key: name, name }));
}

function serializeTenantFilterAdvanced(
  operator: "IN" | "NOTIN",
  tags: ITag[],
): TenantFilters {
  return {
    operator,
    tenantList: tags.map((t) => t.name),
  };
}

// Functions for extension version filters
function parseExtensionVersionFilters(
  extensionVersionFilters?: ExtensionVersionFilters,
): { operator: string; version: string } {
  if (!extensionVersionFilters) {
    return { operator: ">=", version: "" };
  }
  return {
    operator: extensionVersionFilters.operator,
    version: extensionVersionFilters.version || "",
  };
}

function serializeExtensionVersionFilters(
  operator: string,
  version: string,
): ExtensionVersionFilters | undefined {
  if (!version.trim()) return undefined;
  return {
    operator: operator as ">=" | "<=" | "==" | "!=" | "<" | ">",
    version: version.trim(),
  };
}

export {
  parseInitialTags,
  parseTenantFilterAdvancedTags,
  serializeTenantFilterAdvanced,
  parseExtensionVersionFilters,
  serializeExtensionVersionFilters,
};
